import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { MessageCircle, Phone, CalendarCheck, Bot } from "lucide-react";
import { ChatWidget } from "@/components/site/ChatWidget";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { useContent } from "@/lib/queries";
import { COMPANY } from "@/lib/data";

export { useContent };

export default function Layout() {
  const { pathname } = useLocation();
  const { data: content } = useContent();
  const [chat, setChat] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      {content?.announcement && (
        <div className="bg-primary text-primary-foreground text-center text-sm py-2 px-4" data-testid="announcement-bar">{content.announcement}</div>
      )}
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget open={chat} setOpen={setChat} />
      <div className="no-print fixed bottom-20 sm:bottom-5 right-4 sm:right-5 z-40 flex flex-col items-end gap-3" data-testid="floating-buttons">
        <button onClick={() => setChat((c) => !c)} aria-label="Chat with Onkaal support" data-testid="chat-fab" className="h-12 w-12 rounded-full bg-[#08140E] text-white grid place-items-center shadow-xl hover:scale-110 transition-transform"><Bot className="h-6 w-6" /></button>
        <a href={COMPANY.phoneHref} aria-label="Call Onkaal" data-testid="call-fab" className="hidden sm:grid h-12 w-12 rounded-full bg-sky-600 text-white place-items-center shadow-xl hover:scale-110 transition-transform"><Phone className="h-5 w-5" /></a>
        <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" data-testid="whatsapp-fab" className="hidden sm:grid h-12 w-12 rounded-full bg-[#25D366] text-white place-items-center shadow-xl hover:scale-110 transition-transform"><MessageCircle className="h-6 w-6" /></a>
        <Link to="/book" data-testid="book-fab" className="hidden sm:inline-flex h-12 rounded-full bg-primary text-primary-foreground px-5 items-center gap-2 font-semibold shadow-xl shadow-primary/30 hover:scale-105 transition-transform"><CalendarCheck className="h-5 w-5" />Book Service</Link>
      </div>
      <nav className="no-print sm:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 bg-card/95 backdrop-blur-xl border-t border-border shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.2)]" data-testid="mobile-action-bar">
        <a href={COMPANY.phoneHref} className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-semibold text-sky-700 dark:text-sky-400" data-testid="mobile-bar-call"><Phone className="h-5 w-5" />Call Now</a>
        <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-semibold text-[#1da851]" data-testid="mobile-bar-whatsapp"><MessageCircle className="h-5 w-5" />WhatsApp</a>
        <Link to="/book" className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-semibold bg-primary text-primary-foreground" data-testid="mobile-bar-book"><CalendarCheck className="h-5 w-5" />Book Service</Link>
      </nav>
    </div>
  );
}
